import {getPMSClient} from '../..'
import {getPMSBaseUrl} from '../../services/apiService'
import {createFetchActions} from '../../services/createActions'
import {post} from '../../services/createAPICall'
import {getAllFilesQuery} from './AssetValuesQueries'

export const UPLOAD_ASSET_VALUE_FILE = createFetchActions('UPLOAD_ASSET_VALUE_FILE')
export const GET_ALL_UPLOADED_ASSET_VALUE_FILES = createFetchActions('GET_ALL_UPLOADED_ASSET_VALUE_FILES')

export const uploadAssetValuesFile = data => (dispatch: any) => {
	return dispatch(post(UPLOAD_ASSET_VALUE_FILE, `${getPMSBaseUrl()}/v1/asset-values/upload`, data))
}

export function getAllFiles() {
	return function (dispatch) {
		dispatch({
			type: GET_ALL_UPLOADED_ASSET_VALUE_FILES.triggered,
		})

		getPMSClient()
			.query({
				query: getAllFilesQuery,
				fetchPolicy: 'network-only',
			})
			.then(response => {
				dispatch({
					type: GET_ALL_UPLOADED_ASSET_VALUE_FILES.succeeded,
					response,
				})
			})
	}
}
